/**
 * Test ID utilities for DropdownMenu component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for DropdownMenu trigger
 * @param identifier - DropdownMenu identifier
 * @returns Test ID string
 */
export const setDropdownMenuTriggerTestId = (identifier: string): string =>
  generateTestId("DropdownMenuTrigger", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for DropdownMenu content
 * @param identifier - DropdownMenu identifier
 * @returns Test ID string
 */
export const setDropdownMenuContentTestId = (identifier: string): string =>
  generateTestId("DropdownMenuContent", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for DropdownMenu item
 * @param label - Item label
 * @returns Test ID string
 */
export const setDropdownMenuItemTestId = (label: string): string =>
  generateTestId("DropdownMenuItem", label.replace(/\s+/g, "-").toLowerCase());
